import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getContentfulDataFields } from '../utils/helper';

export interface ContentfulState {
  contentfulData: any;
}

const initialState: ContentfulState = {
  contentfulData: {},
};

export const contentfulSlice = createSlice({
  name: 'contentful',
  initialState,
  reducers: {
    storeContentfulData: (state, action: PayloadAction<any>) => {
      state.contentfulData = getContentfulDataFields(action.payload);
    },
    resetContentfulSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const { storeContentfulData, resetContentfulSlice } =
  contentfulSlice.actions;

export default contentfulSlice.reducer;
